import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

// Constructs the Bootstrap popover instance for DesignSystem::PopoverComponent.
// Bootstrap popovers are opt-in and read their own configuration from the
// element's data-bs-* attributes, so this controller only owns the instance
// lifecycle. Disposing on disconnect matters: with container: 'body' the tip
// lives outside the element, and Turbo would otherwise leave it on the page.
//
// The instance is re-read rather than cached, matching turbo_tooltip_controller:
// other controllers dispose popovers they don't own (capacity_planning_controller),
// and a second dispose() throws — Tooltip#dispose dereferences the element that
// the first call already nulled out.
export default class extends Controller {
  connect() {
    bootstrap.Popover.getOrCreateInstance(this.element);
  }

  disconnect() {
    bootstrap.Popover.getInstance(this.element)?.dispose();
  }

  // For data-bs-trigger="manual" triggers, e.g.
  // data-action="click->bootstrap-popover#toggle"
  show() {
    bootstrap.Popover.getOrCreateInstance(this.element).show();
  }

  hide() {
    bootstrap.Popover.getInstance(this.element)?.hide();
  }

  toggle() {
    bootstrap.Popover.getOrCreateInstance(this.element).toggle();
  }
}
